exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gneyai-rive[data-v-5d2cb1b2]{display:flex;align-items:center;justify-content:center}.global-gney-ai[data-v-5d2cb1b2]{cursor:pointer}", ""]);

// exports
